import { render, staticRenderFns } from "./PerformanceLabel.vue?vue&type=template&id=42f0c11f&scoped=true&"
import script from "./PerformanceLabel.vue?vue&type=script&lang=js&"
export * from "./PerformanceLabel.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceLabel.vue?vue&type=style&index=0&id=42f0c11f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0c11f",
  null
  
)

export default component.exports